// extracted by mini-css-extract-plugin
export default {"nameLink":"InventoryTopologiesTable_nameLink__JP08I","nameButton":"InventoryTopologiesTable_nameButton__EOk2M"};